// 组件类名前缀
export const CLASS_PREFIX = 'unv';

export function usePrefixCls(suffixCls?: string): string {
  return suffixCls ? `${CLASS_PREFIX}-${suffixCls}` : CLASS_PREFIX;
}
